// Build-time variant flag. Set via REACT_APP_VARIANT in CI (deploy.yml builds the
// app twice — once for blagoustroistvo.iritual.kz, once for pamyatniki.iritual.kz).
//
// Used to:
//   - tell the API which slice of the catalog to fetch (?variant=...)
//   - gate variant-specific UI (steps, scene, sidebar) under isPamyatniki
//
// Default 'blagoustroistvo' keeps current production behavior if the env var
// is missing for any reason.
export const VARIANT = process.env.REACT_APP_VARIANT || 'blagoustroistvo';
export const isPamyatniki = VARIANT === 'pamyatniki';
export const isBlagoustroistvo = VARIANT === 'blagoustroistvo';
